export default "https://cdn-static.gokick.com/assets/b944ecdade3ab4b24738bd1fcec1eea00d00fb75/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";